<template>
  <v-card>
    <DataTablePagination
      :page="page"
      :total-items="totalItems"
      :headers="headers"
      :items="employees"
      :search="search"
      title="Bagian Pegawai"
      subtitle="Halaman untuk menambahkan bagian pegawai pada sekolah"
      add-btn="Tambah Data"
      :total-pages.sync="totalPages"
      @add-item="showFormAdd"
      @edit-item="showFormEdit"
      @delete-item="confirmDestroy"
    >
    </DataTablePagination>

    <ModalDialog
      :visible="modalDialog"
      :width="width"
      @close="modalDialog = false"
    >
      <template
        v-if="dialog == 'add'"
        v-slot:header
      >
        Tambah Pegawai
      </template>
      <template
        v-else
        v-slot:header
      >
        Update Pegawai
      </template>
      <template v-slot:body>
        <div>
          <v-text-field
            label="Nama Pegawai"
            type="text"
            outlined
            dense
          >
          </v-text-field>
        </div>
      </template>
      <template v-slot:footer>
        <v-btn
          v-if="dialog == 'add'"
          color="primary"
          large
        >
          Tambah
        </v-btn>
        <v-btn
          v-if="dialog == 'edit'"
          color="primary"
          large
        >
          Update
        </v-btn>
        <v-btn
          color="primary"
          outlined
          large
        >
          Batal
        </v-btn>
      </template>
    </ModalDialog>
    <ConfirmDialog
      :visible="confirmDialog"
      @close="confirmDialog = false"
    >
      <template v-slot:header>
        Delete Confirm
      </template>
      <template v-slot:body>
        Are you sure you want to delete this data?
      </template>
      <template v-slot:footer>
        <v-btn
          color="primary"
          outlined
          large
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          large
        >
          Delete
        </v-btn>
      </template>
    </ConfirmDialog>
  </v-card>
</template>

<script>
import DataTablePagination from '../components/DataTablePagination.vue'
import ModalDialog from '../components/ModalDialog.vue'
import ConfirmDialog from '../components/ConfirmDialog.vue'

export default {
  name: 'LessonSchedule',
  components: {
    DataTablePagination,
    ModalDialog,
    ConfirmDialog,
  },
  data() {
    return {
      page: 1,
      modalDialog: false,
      confirmDialog: false,
      totalPages: 0,
      totalItems: 10,
      width: 600,
      search: '',
      dialog: null,
      headers: [
        { text: 'No', value: '' },
        { text: 'Bagian Pegawai', value: 'status_work' },
        { text: 'Aksi', value: 'actions' },
      ],
      employees: [],
      service: 'employee',
    }
  },
  mounted() {
    this.getEmployee()
  },
  methods: {
    showFormAdd() {
      this.dialog = 'add'
      this.modalDialog = true
    },
    showFormEdit() {
      this.dialog = 'edit'
      this.modalDialog = true
    },
    confirmDestroy() {
      this.confirmDialog = true
    },
    getEmployee(params = {}) {
      this.$services.ApiServices.list(this.service, { ...params }).then(
        ({ data }) => {
          this.employees = data.data
          this.totalItems = data.meta.total
          this.totalPages = data.meta.last_page
        },
        err => console.error(err),
      )
    },
  },
}
</script>

<style>
</style>
